import { render, staticRenderFns } from "./QueueHealthStrip.vue?vue&type=template&id=15dfde20&scoped=true"
import script from "./QueueHealthStrip.vue?vue&type=script&lang=js"
export * from "./QueueHealthStrip.vue?vue&type=script&lang=js"
import style0 from "./QueueHealthStrip.vue?vue&type=style&index=0&id=15dfde20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dfde20",
  null
  
)

export default component.exports